export const DataGroup = {
  BRAND: 'BRAND',
  AGENCY: 'AGENCY',
} as const
